import * as React from "react";
import IconButton from "../../components/button/IconButton";
import {ButtonGroup} from "react-bootstrap";


const columns = (t) => [
    {
        field: "id",
        label: t ? t("common.id") : "ID",
        sort: "desc",
        width: 53,
    },
    {
        field: "inventoryStartDate",
        label: t ? t("common.inventory_start") : "Początek inwentaryzacji",
        sort: "desc",
        width: 53,
    },
    {
        field: "inventoryStartUser",
        label: t ? t("common.user_started") : "Użytkownik rozpoczął",
        sort: "desc",
        width: 53,
    },
    {
        field: "inventoryEndDate",
        label: t ? t("common.inventory_end") : "Koniec inwentaryzacji",
        sort: "desc",
        width: 53,
    },
    {
        field: "inventoryEndUser",
        label: t ? t("common.user_finished") : "Użytkownik zakończył",
        sort: "desc",
        width: 53,
    },
    {
        field: "actions",
        label: t ? t("common.actions") : "Akcje",
        sort: "desc",
        width: 30,
        type: "custom",
        custom: function (column, row, history, reload, setReload, setLoader) {

            return <ButtonGroup>
                <IconButton variant={"outline-primary"}
                            icon={"fa-info-circle"}
                            tooltip={t ? t("tooltips.details") : "Szczegóły"}
                            onClick={() => {
                                history.push("/font/" + row.machine.id + "/inventory/" + row.id);
                            }}
                />
            </ButtonGroup>;
        }

    }


]
;


export default columns;